<template>
  <div>
    <section-definition :title="page.title" :extraOptions="page.options" :icon="page.icon" :breadcrumbs="page.breadcrumbs"
      :addNewData="page.addnew" :exportOptions="page.exportOptions" @openFilter="filterClick"
      @refreshPage="refreshThisPage" @addNew="AddNewRule" :style="styleObject">
    </section-definition>
    <loader v-if="page.loading"></loader>
    <v-container v-else fluid grid-list-xl page>
      <v-data-table :headers="headers" :items="TitleData" class="elevation-1 fixed-layout"
        :pagination.sync="pagination" :total-items="pagecount" :loading="tableLoading" :rows-per-page-items="[10]">
        <template v-slot:no-data style="text-align: center">
          <div style="text-align: center">No Data Available</div>
        </template>
        <template v-slot:items="props">
          <td class="checkEmpty p0">{{ props.item.title }}</td>
          <td class="checkEmpty p0">{{ props.item.sub_title }}</td>
          <td class="checkEmpty p0">{{ props.item.description }}</td>
          <td class="checkEmpty p0">
            <template v-if="props.item.is_active === '1'">Active</template>
            <template v-else>Inactive</template>
          </td>
          <td class="text-xs-center checkEmpty p0">      
              <v-icon v-if="props.item.is_default == 0 && page.canedit"
                color="blue"
                small
                class="mr-4"
                @click="editItem(props.item)"
                >edit</v-icon
              >
              <v-icon v-if="props.item.is_default == 0 && page.candelete"
                color="red"
                small
                class="mr-4"
                @click="deleteItem(props.item)"
                >delete
              </v-icon>
              <v-icon v-if="props.item.is_default == 1 && page.canedit"
                color="gray"
                small
                class="mr-4"
                >edit</v-icon
              >
              <v-icon v-if="props.item.is_default == 1 && page.candelete"
                color="gray"
                small
                class="mr-4"
                >delete
              </v-icon>
            </td>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog persistent v-model="DeleteRowdata" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-card-title>
            <span class="headline">Delete Meeting Title</span>
          </v-card-title>
        </v-toolbar>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-card-text>{{ deletemsg }}</v-card-text>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="light" flat @click="closedelete()">Cancel</v-btn>
          <v-btn color="primary" @click="savedelete()">Yes, Delete !</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template>
      <v-dialog persistent :value="page.isAddPausecode" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Create Meeting Title</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="meetingtitle" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="addMeetingtitle.payload.title" required label="Meeting Title" type="text" ref="titleField"
                    :rules="titleRules"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="addMeetingtitle.payload.sub_title" required label="Meeting Sub Title" type="text" :rules="subTitleRules" ref="subTitleField"
                      ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="addMeetingtitle.payload.description" required label="Description" type="text"
                      :rules="[(v) => !!v || 'Description is required']"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closeAddPausecode()">Close</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="saveAddPausecode()">Create</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-dialog persistent :value="page.isEditPausecode" scrollable max-width="500px">
        <v-card>
          <v-toolbar dark color="primary">
            <v-card-title>
              <span class="headline">Update Meeting Title</span>
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="update" v-model="updatevalid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field readonly v-model="editMeetingtitle.title" required label="Meeting Title" type="text"
                    :rules="[(v) => !!v || 'Meeting Title is required',(v) => !/^others\s*$/.test(v)  || 'Meeting Title must not contain others',(v) => !/^other\s*$/.test(v)  || 'Meeting Title must not contain other']"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="editMeetingtitle.sub_title" required label="Meeting Sub Title" type="text" :rules="editSubTitleRules"
                     ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field v-model="editMeetingtitle.description" required label="Description" type="text"
                      :rules="[(v) => !!v || 'Description is required']"></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select v-model="editMeetingtitle.is_active" required label="Status" :items="is_active"
                      :rules="[(v) => !!v || 'Status is required']"></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="modal-footer--sticky">
            <v-spacer></v-spacer>
            <v-btn color="light" flat @click="closeEditRules()">Close</v-btn>
            <v-btn color="primary" :disabled="!updatevalid" @click="saveEditRules()">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <v-navigation-drawer fixed disable-resize-watcher right v-model="page.isFilterOpen">
      <v-toolbar small color="secondary" style="color: white">
        <v-toolbar-title>Filter</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon flat color="white" @click="page.isFilterOpen = false">
          <i class="fas fa-close"></i>
        </v-btn>
      </v-toolbar>
      <div class="flex-column justify-sb height-100-exclude-toolbar overflow-auto">
        <v-container class="sidenavContainer">
          <div class="autocompleteDiv">
            <v-select v-model="filter.payload.title" label="Title" :items="newArray"></v-select>
            <v-select v-model="filter.payload.is_active" label="Status" :items="status"></v-select>
          </div>
        </v-container>
        <v-container row class="sidenavFooter">
          <v-btn flat @click="reset()">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="disabling()" @click="getDataFromApi()">Filter</v-btn>
        </v-container>
      </div>
    </v-navigation-drawer>
    <v-snackbar v-model="snackbar.show" :bottom="true" :right="true" :timeout="snackbar.timeout">
      {{ snackbar.text }}
      <v-btn color="pink" flat @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="isProcessing" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import loader from "@/components/Widgets/loader";
//import api from "@/utils/axios-util";
import { mapGetters } from "vuex";
export default {
  components: {
    loader,
  },

  data() {
    return {
      valid: true,
      updatevalid: true,
      styleObject: {
        height: "80px",
        "margin-top": "-8px",
      },
      page: {
        title: "Meeting Title",
        icon: "fa-envelope fa-2x",
        loading: false,
        isAddPausecode: false,
        isFilterOpen: false,
        playingRecord: false,
        breadcrumbs: [],
        exportOptions: [],
        options: { filter: true, refresh: true, autoCompletePC: true },
        addnew: [],
        isEditPausecode: false,
        temp: { key: "addmeetingtitle", label: "Add Meeing Title" },
        candelete: false,
        timeModal: false,
        timeModal1: false,
        canedit: false,
      },
      pagecount: 0,
      headers: [
        {
          text: "Title",
          align: "left",
          class: "p0",
          sortable: false,
          value: "title",
        },
        {
          text: "Sub Title",
          align: "left",
          class: "p0",
          sortable: false,
          value: "sub_title",
        },
        {
          text: "Description",
          align: "left",
          class: "p0",
          sortable: false,
          value: "description",
        },
        {
          text: "Status",
          align: "left",
          class: "p0",
          sortable: false,
          value: "status",
        },

        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "btn",
          // width: "20%",
        },
      ],
      TitleData: [],
      //pagecount: 0,
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      snackbar: {
        show: false,
        timeout: 6000,
        text: "",
      },
      DeleteRowdata: false,
      showRowData: false,
      DataRow: false,
      tableLoading: false,
      crmdomain: "",
      filtervalue: [],
      newArray: [],

      filter: {
        payload: {
          title: "",
          is_active: ""
        },
        options: {
          status: ["Active", "Inactive"],
        },
        isLoading: false,
      },
      status: ["Active", "Inactive"],

      isProcessing: false,
      call_status: [],
      editMeetingtitle: {
        id: "",
        sub_title: "",
        description: "",
        is_active: ""
      },
      addMeetingtitle: {
        valid: false,
        payload: {
          title: "",
          description: "",
          sub_title: "",
          module: "meeting",
        },
      },
      is_active: ["Active", "Inactive"],
      deletemsg: '',
      deleted_data: {}
    };
  },
  methods: {
    refreshThisPage: function () {
      var scope = this;
      scope.page.loading = true;
      scope.pagination.page = 1;
      scope.filter.payload.title = "";
      scope.filter.payload.is_active = "";

      scope.getDataFromApi();
    },
    filterClick: function () {
      this.page.isFilterOpen = true;
    },

    reset() {
      var scope = this;
      scope.filter.payload.title = "";
      scope.filter.payload.is_active = "";  
      scope.getDataFromApi();
      this.page.isFilterOpen = true;
     
    },
    disabling(){
      return false // this.filter.payload.title === '' && this.filter.payload.is_active === ''
    },
    getFilterDropdownData() {
      var scope = this;
      this.$store
        .dispatch("FetchData", { take: 1000, skip: 0 }) 
        .then((response) => {
          if(response.data)
          scope.newArray = response.data.map((element) => element.title);
        })
        .catch(function (error) {
          scope.showSnackBar("error" + error);
        });
    },

    getDataFromApi() {
      var scope = this;
      scope.tableLoading = true;

      this.page.isFilterOpen = false;
      let take = this.pagination.rowsPerPage;
      let skip;
      if (this.pagination.page === 1) {
        skip = 0;
      } else {
        skip = this.pagination.rowsPerPage * (this.pagination.page - 1);
      }
      scope.filter.payload["skip"] = skip;
      scope.filter.payload["take"] = take;
      scope.skip = skip;
      this.$store
        .dispatch("FetchData", scope.filter.payload)
        .then((response) => {
          if(response.statusCode===200){
          this.pagecount = response.count;
          scope.tableLoading = false;
          scope.page.loading = false;
          var datas = response.data ? response.data : [];
          if(scope.disabling()){
            scope.newArray = datas.map((element) => element.title);
          }
          scope.TitleData = datas;
          }else{
            scope.tableLoading = false;
            scope.page.loading = false;
            scope.TitleData = []
            //scope.showSnackBar("Data is not available");
          }
        })
        .catch(function (error) {
          scope.page.isAddPausecode = false;
          scope.showSnackBar("error" + error);
          this.page.isEditPausecode = false;
        });
    },
    AddNewRule: function () {
      //var scope = this;
      this.page.isAddPausecode = true;
    },
    closeEditRules: function () {
      this.page.isEditPausecode = false;
    },
    closeAddPausecode: function () {
      this.page.isAddPausecode = false;
      this.$refs.meetingtitle.reset();
    },
    saveEditRules() {
      var scope = this;
      if (this.editMeetingtitle.is_active == "Active") {
        this.editMeetingtitle.is_active = "1"
      } else {
        this.editMeetingtitle.is_active = "0"

      }
      scope.$store
        .dispatch("updateMeetingTitle", scope.editMeetingtitle)
        .then(() => {
          scope.page.isAddPausecode = false;
          scope.showSnackBar("Updated Successfully");
          scope.getDataFromApi();
          scope.page.isEditPausecode = false;
        })
        .catch(function (error) {
          scope.page.isAddPausecode = false;
          scope.showSnackBar("error" + error);
          scope.page.isEditPausecode = false;
        });
      scope.getDataFromApi();
    },
    saveAddPausecode() {
      var scope = this;
      if(scope.addMeetingtitle.payload.title === scope.addMeetingtitle.payload.sub_title){
        return
      }
      scope.$store
        .dispatch("insertMeetingtitle", scope.addMeetingtitle.payload)
        .then(() => {
          scope.page.isAddPausecode = false;

          scope.showSnackBar("Created Successfully");
          scope.getDataFromApi();
          scope.$refs.meetingtitle.reset();
        })
        .catch(function (error) {
          scope.page.isAddPausecode = false;
          if (error.response && error.response.status === 409) {
            scope.showSnackBar("The meeting title already exists");
          }
        });
      this.getDataFromApi();
    },
    showSnackBar(message) {
      let scope = this;
      scope.snackbar.text = message;
      scope.snackbar.show = true;
      setTimeout(() => {
        scope.snackbar.text = "";
      }, scope.snackbar.timeout);
    },
    deleteItem(data) {
      let scope = this
      scope.delete_id = data.id;
      scope.deletemsg = `Are you sure to delete this Meeting Title?`
      this.DeleteRowdata = true;
    },
    editItem(item) {
      this.page.isEditPausecode = true;
      this.editMeetingtitle.id = item.id;
      this.editMeetingtitle.title = item.title;
      this.editMeetingtitle.description = item.description;
      this.editMeetingtitle.sub_title = item.sub_title


      if (item.is_active === "1") {
        this.editMeetingtitle.is_active = "Active";
      } else {
        this.editMeetingtitle.is_active = "Inactive";
      }
    },
    savedelete() {
      let scope = this;
      scope.isProcessing = true;
      scope.filtervalue = [];
      this.$store
        .dispatch("deleteMeetingTitle", scope.delete_id)
        .then((response) => {
          scope.isProcessing = false;
          if (response.data.message == "success") {
            scope.getDataFromApi();
            scope.showSnackBar("Meeting Title Deleted");
          } else {
            scope.showSnackBar("Error! Unable Delete Meeting Title");
          }
        })
        .catch(() => {
          scope.isProcessing = false;
          scope.showSnackBar("Error! Unable Delete list");
        });
      this.closedelete();
    },
    closedelete() {
      this.DeleteRowdata = false;
    },
    closeShow() {
      this.showRowData = false;
    },
  },
  computed: {
    ...mapGetters(["CallFlow"]),
    titleRules() {
      return [
        v => !!v || 'Meeting Title is required',
        v => !/^others\s*$/i.test(v) || 'Meeting Title must not contain "others"',
        v => !/^other\s*$/i.test(v) || 'Meeting Title must not contain "other"',
        v => v !== this.addMeetingtitle.payload.sub_title || 'Meeting Title and Sub Title must not be the same'
      ];
    },
    subTitleRules() {
      return [
        v => v !== this.addMeetingtitle.payload.title || 'Meeting Sub Title and Title must not be the same'
      ];
      
    },
    editSubTitleRules() {
      return [
        v => v !== this.editMeetingtitle.title || 'Meeting Sub Title and Title must not be the same'
      ];
    }
  },
  mounted() {
    let scope = this;
    this.page.loading = false;
    setTimeout(
      function () {
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:pausecode:create"
          ) !== -1
        ) {
          scope.page.addnew = [{ label: "Add Meeting Title" }];
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:pausecode:edit"
          ) !== -1
        ) {
          scope.page.canedit = true;
        }
        if (
          scope.$store.getters.UserPermissions.indexOf(
            "configurations:pausecode:delete"
          ) !== -1
        ) {
          scope.page.candelete = true;
        }
      }.bind(scope),
      1
    );
    const project_config = JSON.parse(localStorage.projectConfig);
    this.crmdomain = project_config.projects[0].config[0].crm_domain;
    this.getDataFromApi();
    this.getFilterDropdownData();
  },
  watch: {
    pagination: {
      handler() {
        if (this.pagination.page > 1 || this.skip >= 10) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  'addMeetingtitle.payload.title'(){
    this.$refs.subTitleField.validate()
  },
  'addMeetingtitle.payload.sub_title'(){
    this.$refs.titleField.validate();
  }
  },
};
</script>
<style>
.mr-4 {
  text-align: start;
}

.file-dummy {
  width: 100%;
  padding: 30px;
  border: 2px dashed;
  text-align: center;
  transition: #2196f333 0.3s ease-in-out;
  cursor: pointer;
  font-weight: bold;
}
</style>